import { DeviceType } from '@/app/components/DeviceSelectionGallery/DeviceSelectionGallery.types'
import { RootState } from '@/reducers'
import { ID } from '@/types/model'
import { match } from 'ts-pattern'
import { vehicleDemandResponseEventsCollection } from '@/reducers/vehicleDemandResponseEvents'

export function selectNextVehicleDREvent(state: RootState, vehicleId: ID) {
  const events =
    vehicleDemandResponseEventsCollection.selectors.selectAll(state)
  return events.find((delayEvent) => delayEvent.vehicle_id === vehicleId)
}

export function selectNextDeviceDREvent(
  state: RootState,
  deviceId: ID,
  deviceType: DeviceType,
) {
  const events =
    vehicleDemandResponseEventsCollection.selectors.selectAll(state)
  return events.find((delayEvent) =>
    match(deviceType)
      .with('vehicle', () => delayEvent.vehicle_id === deviceId)
      .with('vehicleCharger', () => delayEvent.charger_id === deviceId)
      .otherwise(() => false),
  )
}
